import React from 'react'

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles(() => ({
  paper: {
    width: '100%',
  },
  width: {
    width: '190px',
  },
}))

const SectionTable = ({ sectionName, children, showFirstYearHeader, showTransferHeader, onlyShowLabel, getStyle }) => {
  const styles = useStyles()

  return (
    <Paper
      className={styles.paper}
      elevation={0}
    >
      <TableContainer>
        <Table
          autoComplete="on"
          aria-label={sectionName}
        >
          <TableHead>
            <TableRow>
              <TableCell
                style={{ color: getStyle && getStyle() }}
                align="left"
              >
                {sectionName}
              </TableCell>
              {!onlyShowLabel && (
                <React.Fragment>
                  <TableCell
                    role={showFirstYearHeader ? undefined : 'none'}
                    className={styles.width}
                    style={{ color: getStyle && getStyle() }}
                    align="left"
                  >
                    {showFirstYearHeader && 'First-Year'}
                  </TableCell>
                  <TableCell
                    role={showTransferHeader ? undefined : 'none'}
                    className={styles.width}
                    style={{ color: getStyle && getStyle() }}
                    align="left"
                  >
                    {showTransferHeader && 'Transfer'}
                  </TableCell>
                </React.Fragment>
              )}
            </TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  )
}

SectionTable.propTypes = {
  sectionName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  showFirstYearHeader: PropTypes.bool,
  showTransferHeader: PropTypes.bool,
  onlyShowLabel: PropTypes.bool,
  getStyle: PropTypes.func,
}

SectionTable.defaultProps = {
  showFirstYearHeader: true,
  showTransferHeader: true,
  onlyShowLabel: false,
}

export default SectionTable
